import React from 'react';
import { motion } from 'framer-motion';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = 'medium', text }) => {
  const sizeClasses = {
    small: 'w-3 h-3',
    medium: 'w-6 h-6', 
    large: 'w-8 h-8'
  };

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="flex flex-col items-center justify-center"
    >
      <div className={`relative ${sizeClasses[size]}`}>
        {/* Background circle */}
        <div className="absolute inset-0 rounded-full border-2 border-gray-200"></div>
        {/* Animated spinner */}
        <div 
          className="absolute inset-0 rounded-full border-2 border-transparent border-t-red-500 animate-spin"
          style={{ animationDuration: '1s', animationTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
        ></div>
      </div>
      {text && (
        <motion.p 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.3 }}
          className="mt-3 text-gray-600 text-sm font-medium"
        >
          {text}
        </motion.p>
      )}
    </motion.div>
  );
};

export default Loader;